import {Controller} from "stimulus"

export default class extends Controller {
    push(ev) {
        let value = ev.target.value
        let key = ev.target.dataset.var ?? ev.target.id ?? 'var'
        this.data.set(key, value)
    }
}
